import React from "react";
import { Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { history } from "../_helpers/history";
import {
    getIncompleteFields,
    getMissingFieldsLabel,
} from "../utils/profileCompleteness";
import styles from "./styles/CompleteProfileCard.module.css";

function CompleteProfileCard({ organization }) {
    const incompleteFields = getIncompleteFields(organization);

    if (incompleteFields.length === 0) return null;

    const missingLabel = getMissingFieldsLabel(incompleteFields);

    const handleClick = () => {
        if (organization?.id) {
            history.push(`/settings/brand/${organization.id}/edit`);
        }
    };

    return (
        <div className={styles.card} onClick={handleClick}>
            <div className={styles.iconWrapper}>
                <ExclamationCircleOutlined />
            </div>
            <div className={styles.content}>
                <h4>Complete Your Setup</h4>
                <p>Missing: {missingLabel}</p>
            </div>
            <Button type="primary" size="small">
                Complete Now
            </Button>
        </div>
    );
}

export default CompleteProfileCard;
